export default {
  en: {
    createPartner: 'Create Partner',
    partnerName: 'Partner Name',
    createUserForPartner: 'Create user for the partner',
    checkEmailAndFollowInstructionsInfo: 'Please check email and follow the instructions provided in the link.',
    editPartner: 'Edit Partner',
    lPartner: 'partner',
    removeMaintenance: 'Remove Maintenance',
    manageMaintenanceInfo: 'Maintenance will only apply to Active brands. The Start Date will not apply to brands in Maintenance status.',
    removeMaintenanceInfo: 'Partner brands that are in “Maintenance” state will be immediately changed to “Active',
    hasMaintenance: 'Has Maintenance',
    bulkRemoveMaintenanceInfo: 'Selected partner brands that are in Maintenance status will be immediately changed to Active',
    playersSelfExclusionSyncInfo: 'Automatically apply self-exclusion across brands under the same License ID. Player identification is based on verified CNP',
    paydromEnvironment: 'Paydrom Environment',
    paydromEnvironmentUrlsInfo: 'The brand will redirect the payment calls to the mentioned servers:',
    playersVerificationSync: 'Players Verification Sync',
    playersVerificationSyncInfo: 'Automatically apply Identity Verification across brands under the same License ID. Player identification is based on verified CNP',
    playersSelfExclusionSync: 'Players Self-Exclusion Sync',
    brandsSynchronization: 'Brands Synchronization',
    securityConfigurations: 'Security Configurations',
    securityConfigurationInfo: 'Manage security settings for Admin Panel users under this Partner.',
    hreflangGroups: 'Hreflang Groups',
    hreflangGroupsInfo: 'A group can include only brands belonging to this Partner. A brand can belong to one Hreflang Group only',
    addGroup: 'Add Group',
    brands: 'Brands\'',
  },
  es: {
    createPartner: 'Crear socio',
    partnerName: 'Nombre del socio',
    createUserForPartner: 'Crear usuario para el socio',
    checkEmailAndFollowInstructionsInfo: 'Compruebe el correo electrónico y siga las instrucciones proporcionadas en el enlace.',
    editPartner: 'Editar socio',
    lPartner: 'socio',
    removeMaintenance: 'Eliminar mantenimiento',
    manageMaintenanceInfo: 'El mantenimiento solo se aplicará a las marcas activas. La fecha de inicio no se aplicará a las marcas en estado de mantenimiento.',
    removeMaintenanceInfo: 'Las marcas asociadas que estén en estado “Mantenimiento” serán cambiadas inmediatamente a “Activo”.',
    hasMaintenance: 'Tiene mantenimiento',
    bulkRemoveMaintenanceInfo: 'Las marcas asociadas seleccionadas que estén en estado de mantenimiento serán cambiadas inmediatamente a activo.',
    playersSelfExclusionSyncInfo: 'Aplicar automáticamente la autoexclusión en todas las marcas bajo la misma ID de licencia. La identificación del jugador se basa en CNP verificado.',
    paydromEnvironment: 'Entorno de Paydrom',
    paydromEnvironmentUrlsInfo: 'La marca redirigirá las llamadas de pago a los servidores mencionados:',
  },
  tr: {
    createPartner: 'Partner Oluştur',
    partnerName: 'Partnerin Adı',
    createUserForPartner: 'Partner için kullanıcı oluştur',
    checkEmailAndFollowInstructionsInfo: 'Lütfen e-postanızı kontrol edin ve linkte belirtilen talimatları uygulayın.',
    editPartner: 'Partner Düzenle',
    lPartner: 'Partner',
    removeMaintenance: 'Bakımı Kaldır',
    manageMaintenanceInfo: 'Bakım yalnızca Aktif markalar için geçerli olacaktır. Başlangıç Tarihi, Bakım durumundaki markalar için geçerli olmayacaktır.',
    removeMaintenanceInfo: '“Bakım” durumunda olan partner markalar hemen “Aktif” durumuna geçirilecektir.',
    hasMaintenance: 'Bakım Var',
    bulkRemoveMaintenanceInfo: 'Bakım durumunda olan seçilmiş partner markalar hemen Aktif durumuna geçirilecektir.',
    playersSelfExclusionSyncInfo: "Aynı Lisans ID'si altındaki markalar arasında otomatik olarak kendi kendini hariç tutma uygular. Oyuncu tanımlama, doğrulanmış CNP'ye göre yapılır.",
  },
  ru: {
    createPartner: 'Создать партнера',
    partnerName: 'Имя партнера',
    createUserForPartner: 'Создать пользователя для партнера',
    checkEmailAndFollowInstructionsInfo: 'Проверьте почту и следуйте инструкциям, доступным по ссылке.',
    editPartner: 'Редактировать партнера',
    lPartner: 'Партнер',
    removeMaintenance: 'Убрать обслуживание',
    manageMaintenanceInfo: 'Обслуживание применяется только к активным брендам. Дата начала не будет применяться к брендам, находящимся в статусе «Обслуживание».',
    removeMaintenanceInfo: 'Партнерские бренды, находящиеся в состоянии «Обслуживание», будут немедленно переведены в состояние «Активный»',
    hasMaintenance: 'Имеет обслуживание',
    bulkRemoveMaintenanceInfo: 'Выбранные партнерские бренды, находящиеся в статусе «Обслуживание», будут немедленно переведены в статус «Активный»',
    playersSelfExclusionSyncInfo: 'Автоматическое применение самоисключения для всех брендов с одним и тем же ID лицензии. ID игрока основывается на верифицированном CNP',
    paydromEnvironment: 'Среда Paydrom',
    paydromEnvironmentUrlsInfo: 'Бренд будет перенаправлять запросы на оплату на указанные серверы:',
  },
  pt: {
    createPartner: 'Criar Parceiro',
    partnerName: 'Nome do Parceiro',
    createUserForPartner: 'Criar utilizador para o parceiro',
    checkEmailAndFollowInstructionsInfo: 'Por favor, verifique o e-mail e siga as instruções fornecidas no link.',
    editPartner: 'Editar Parceiro',
    lPartner: 'parceiro',
    removeMaintenance: 'Remover manutenção',
    manageMaintenanceInfo: 'A manutenção será aplicada apenas às marcas ativas. A Data de Início não se aplicará às marcas em status de Manutenção.',
    removeMaintenanceInfo: 'As marcas parceiras que estão no estado “Manutenção” serão imediatamente alteradas para “Ativo',
    hasMaintenance: 'Tem manutenção',
    bulkRemoveMaintenanceInfo: 'As marcas parceiras selecionadas que estão em status de Manutenção serão imediatamente alteradas para Ativas',
    playersSelfExclusionSyncInfo: 'Aplique a autoexclusão automaticamente a todas as marcas sob o mesmo ID de licença. A identificação do jogador é baseada no CNP verificado.',
    paydromEnvironment: 'Ambiente Paydrom',
    paydromEnvironmentUrlsInfo: 'A marca redirecionará as chamadas de pagamento para os servidores mencionados:',
  },
  zh: {
    createPartner: '创建合作伙伴',
    partnerName: '合作伙伴名称',
    createUserForPartner: '为合作伙伴创建用户',
    checkEmailAndFollowInstructionsInfo: '请查收电子邮件并按照链接中提供的指示进行操作。',
    editPartner: '编辑合作伙伴',
    lPartner: '合作伙伴',
    removeMaintenance: '解除维护',
    manageMaintenanceInfo: '维护仅适用于活跃品牌。生效日期不适用于维护状态的品牌。',
    removeMaintenanceInfo: '处于“维护”状态的合作伙伴品牌将立即更改为“活跃”',
    hasMaintenance: '有维护',
    bulkRemoveMaintenanceInfo: '处于维护状态的选定合作伙伴品牌将立即更改为活跃状态',
    playersSelfExclusionSyncInfo: '自动在同一许可证ID下跨品牌应用自我排除。玩家身份识别基于已验证的CNP',
    paydromEnvironment: 'Paydrom 环境',
    paydromEnvironmentUrlsInfo: '品牌将把支付请求重定向至指定服务器',
  },
  ro: {
    createPartner: 'Creează un partener',
    partnerName: 'Numele partenerului',
    createUserForPartner: 'Creează utilizator pentru partener',
    checkEmailAndFollowInstructionsInfo: 'Te rugăm să verifici e-mailul și să urmezi instrucțiunile furnizate în link',
    editPartner: 'Editează partenerul',
    lPartner: 'partener',
    removeMaintenance: 'Eliminare întreținere',
    manageMaintenanceInfo: 'Întreținerea se va aplica numai mărcilor Active. Data de început nu se va aplica mărcilor cu starea Întreținere.',
    removeMaintenanceInfo: 'Mărcile partenere aflate în starea „Întreținere” vor trece imediat în starea „Activă”',
    hasMaintenance: 'Se află în întreținere',
    bulkRemoveMaintenanceInfo: 'Mărcile partenere selectate aflate în starea Întreținere vor trece imediat în starea Activă',
    playersSelfExclusionSyncInfo: 'Aplică automat autoexcluderea mărcilor cu același ID de licență. Identificarea jucătorilor se realizează pe bază de CNP verificat',
    paydromEnvironment: 'Mediu Paydrom',
    paydromEnvironmentUrlsInfo: 'Marca va redirecționa solicitările de plată către serverele menționate:',
  },
  bg: {},
  el: {
    createPartner: 'Δημιουργία συνεργάτη',
    partnerName: 'Όνομα συνεργάτη',
    createUserForPartner: 'Δημιουργία χρήστη για τον συνεργάτη',
    checkEmailAndFollowInstructionsInfo: 'Ελέγξτε το email και ακολουθήστε τις οδηγίες που παρέχονται στον σύνδεσμο.',
    editPartner: 'Επεξεργασία συνεργάτη',
    lPartner: 'συνεργάτης',
    removeMaintenance: 'Αφαίρεση συντήρησης',
    manageMaintenanceInfo: 'Η συντήρηση θα εφαρμόζεται μόνο στις Ενεργές επωνυμίες. Η Ημερομηνία Έναρξης δεν θα εφαρμόζεται σε επωνυμίες που βρίσκονται σε κατάσταση Συντήρησης.',
    removeMaintenanceInfo: 'Οι επωνυμίες συνεργατών που βρίσκονται σε κατάσταση «Συντήρησης» θα αλλάζουν αμέσως σε «Ενεργές',
    hasMaintenance: 'Έχει συντήρηση',
    bulkRemoveMaintenanceInfo: 'Οι επιλεγμένες επωνυμίες συνεργατών που βρίσκονται σε κατάσταση Συντήρησης θα αλλάζουν αμέσως σε Ενεργές',
    playersSelfExclusionSyncInfo: 'Αυτόματη εφαρμογή αυτοαποκλεισμού σε επωνυμίες με το ίδιο Αναγνωριστικό Άδειας. Η ταυτοποίηση των παικτών βασίζεται σε επαληθευμένο CNP',
    paydromEnvironment: 'Περιβάλλον Paydrom',
    paydromEnvironmentUrlsInfo: 'Η επωνυμία θα ανακατευθύνει τις κλήσεις πληρωμής στους προαναφερθέντες διακομιστές:',
  },
};
